export default {
                   "messages": {
                       "editor": {
                           "tabs": {
                               "posts": "Articles",
                               "groups": "Organisations"
                           },
                           "post": {
                               "publish": "Publier",
                               "update": "Mettre à jour",
                               "upload-picture": "Changer image",
                               "title": "Titre",
                               "content": "Contenu",
                               "location": "Localité et adresse",
                               "new-event": "Nouvel événement",
                               "edit-post": "Modifier article",
                               "edit-event": "Modifier événement",
                               "post-as": "Publié par",
                               "cant-add-more": "Vous ne pouvez pas ajouter plus de",
                               "images": "Images",
                               "youtube-video": "Vidéo Youtube",
                               "youtube-video-placeholder": "https://www.youtube.com/...",
                               "occurrences": "Sélectionner date...",
                               "occurrences-placeholder": "Date",
                               "post-list": {
                                   "create-new-post": "Créer nouvel article",
                                   "search-post": "Recherche article...",
                                   "last-modification": "Dernière modification le",
                                   "no-result-for": "Aucun résultat pour",
                                   "refine-search": "Veuillez affiner votre recherche pour trouver plus d'articles"
                               },
                               "draft": {
                                   "add-link": "Ajouter lien",
                                   "edit-link": "Modifier lien",
                                   "insert-link": "Insérer lien",
                                   "link-address": "Adresse lien"
                               },
                               "picture-upload": {
                                   "uploading-pictures": "Télécharger images ({processed}/{total})",
                                   "saving": "Sauvegarder"
                               },
                               "not-valid-youtube-link": "Lien Youtube invalide",
                               "not-valid-link": "URL invalide",
                               "delete-post": "Supprimer article",
                               "delete-post-button": "Supprimer",
                               "alert-delete-post": "En confirmant, vous supprimez cet article définitivement : {postTitle}.",
                               "file-size-exceeded": "La taille maximale du fichier est dépassée (10MB)",
                               "errors": {
                                   "body-pic-video": "La description de l'article, de l'image ou de la vidéo doit être plus détaillée",
                                   "bad-group": "Vous n'êtes pas autorisé à publier des articles au nom de l'organisation, parce que vous n'êtes pas membre de l'organisation",
                                   "bad-json": "Mywort est une plate-forme de participation locale au Luxembourg et pour le Luxembourg. Les contributions doivent être rédigées principalement en allemand, français, anglais et portugais. Les autres langues ou caractères spéciaux sont donc à éviter."
                               },
                               "messages": {
                                   "it-might-take-time": "La mise à jour peut prendre quelques minutes.",
                                   "save-success-title": "Votre article a été créé avec succès.",
                                   "edit-success-title": "Votre article a été mis à jour avec succès.",
                                   "delete-success-title": "Votre article a été supprimé."
                               },
                               "social-sharing": {
                                   "message": "Partagez votre article sur les réseaux sociaux"
                               },
                               "linked-mission": "Mission",
                               "language": "Langue"
                           },
                           "group": {
                               "my-groups": "Mes organisations",
                               "joined-groups": "Affiliation",
                               "manage": "Gérer",
                               "manage-group": "Gérer organisation",
                               "leave-group": "Quitter organisation",
                               "new-group": "Créer page pour organisation",
                               "edit-group": "Modifier organisation",
                               "wait-staff-validation": "Votre demande est traitée. Vous recevrez un email sous peu.",
                               "wait-user-validation": "Veuillez attendre la validation de votre demande.",
                               "declined-by-user": "Votre demande a été refusée par l'administrateur de l'organisation.",
                               "join-requests": "Demandes",
                               "maintainers": "Membres",
                               "no-users-request": "Aucun membre jusqu'à présent",
                               "no-join-request": "Aucune demande d'affiliation jusqu'à présent",
                               "show-declined-requests": "Afficher demandes refusées",
                               "delete-group": "Supprimer organisation",
                               "alert-leave-group": "En confirmant, vous quittez l'organisation '{groupName}' définitivement.",
                               "alert-delete-group": "En confirmant, vous supprimez l'organisation '{groupName}' définitivement. Par cette action, l'organisation sera supprimée et les articles seront affichés avec le nom de l'auteur.",
                               "please-enter-reason": "Veuillez indiquer la raison...",
                               "owner": "Administrateur",
                               "picture-upload": {
                                   "crop-picture": "Modifier image",
                                   "preview-picture": "Aperçu",
                                   "upload-picture": "Changer image",
                                   "errors": {
                                       "default-error": "L'image est corrompue ou dans un format non autorisé",
                                       "bad-size": "Taille d'image non autorisée ({maxSize}mb maximum, {minWidth}px largeur minimum)"
                                   }
                               }
                           }
                       },
                       "search": {
                           "placeholder": "Texte, localité, organisation",
                           "for": "Rechercher '{input}' sur mywort",
                           "starttyping": "Saisir texte...",
                           "noresults": "Aucun résultat trouvé",
                           "title": "Recherche...",
                           "loading": "Recherche en cours...",
                           "results-all": "Résultats de recherche",
                           "results-for": "Résultats de recherche pour \"{item}\"",
                           "results-around": "dans {locality}",
                           "results-by": "publié par {group}",
                           "discover-more": "Découvrez plus",
                           "filters": {
                               "title": "Filtre",
                               "reset": "Réinitialiser filtre",
                               "date": {
                                   "placeholder": "Date"
                               },
                               "locality": "Localité",
                               "municipality": "Commune",
                               "around": "Région"
                           },
                           "suggestions": {
                               "locality": "Localité trouvée pour",
                               "localities": "Localités trouvées pour",
                               "group": "Organisation trouvée pour",
                               "groups": "Organisations trouvées pour"
                           }
                       },
                       "public": {
                           "click-localize": "Cliquez ici pour définir la localisation",
                           "remove-localization": "Supprimer localisation",
                           "localization-error": "Vous avez refusé de partager votre localité. Vous pouvez à tout moment changer et définir la localisation dans votre browser.",
                           "my-position": "Ma position",
                           "type-city": "Saisissez du texte pour sélectionner une localité",
                           "more": "Plus",
                           "published-at": "publié le",
                           "search": "Recherche",
                           "advanced-search": "Recherche avancée",
                           "please-enter-something": "Veuillez saisir du texte",
                           "unlink-post": {
                               "unlink": "Supprimer lien",
                               "sure-to-unlink": "Cette action est irrévocable. Voulez-vous vraiment supprimer le lien vers ce post?"
                           },
                           "legacy-group-request": {
                               "want-create-group": "Je souhaite créer cette organisation",
                               "already-did-request": "Vous avez créé l'organisation.",
                               "wait-for-validation": "Une demande a été envoyée à l'administrateur de mywort.lu pour validation.",
                               "legacy-organisation": "Devenez administrateur d'une organisation qui a été importée de l'ancien site web.",
                               "group-request-message": "Vous êtes autorisé à demander la reprise de l'administration de cette organisation qui a été importée de l'ancien site web. Soyez le/la premier/ère, cliquez ici et..."
                           },
                           "group-ownership-request": {
                               "become-owner": "Devenez administrateur d'organisation",
                               "group-ownership-message": "Publiez vos articles au nom de l'organisation",
                               "want-to-own": "Reprendre l'organisation",
                               "email-subject": "Demande de reprise d'une organisation",
                               "email-body": "Bonjour, j'aimerais reprendre l'administration de l'organisation '{groupName}'. Meilleures salutations, {ownerName}"
                           },
                           "group-request": {
                               "modal": {
                                   "group-name": "Nom de l'organisation",
                                   "description": "Description"
                               }
                           },
                           "join-group-request": {
                               "modal": {
                                   "title": "Envoyer une demande d'affiliation",
                                   "comments-to-owner": "Cher responsable d'organisation, \n" +
                                       "J'aimerais contribuer à votre organisation et écrire des articles au nom de votre organisation. \n" +
                                       "Est-ce que ça vous conviendrait ? \n" +
                                       "Merci !"
                               },
                               "want-join-group": "Rejoindre l'organisation",
                               "already-did-request": "Vous avez déjà envoyé une demande d'affiliation à cette organisation",
                               "wait-for-validation": "Une demande d'affiliation a été envoyée à l'administrateur de l'organisation pour validation",
                               "please-enter-comment": "Veuillez saisir un commentaire...",
                               "become-maintainer": "Devenez membre",
                               "join-group-message": "En tant que membre, vous êtes autorisé à créer des articles au nom de l'organisation. Cliquez sur le bouton pour envoyer une demande d'affiliation à l'administrateur de l'organisation."
                           }
                       },
                       "user-module": {
                           "signup-login": "Login",
                           "manage-posts": "Gérer articles<br>",
                           "latest-posts": "Articles récents",
                           "manage-groups": "Gérer organisations<br>",
                           "logout": "Logout",
                           "add-post": "Ajouter article",
                           "my-articles": "Articles",
                           "my-groups": "Organisations",
                           "login-mywort": "Se connecter",
                           "logout-mywort": "Se déconnecter",
                           "settings-mywort": "Modifier le profil",
                           "profile": "Profil",
                           "empty-post": "Aucun post actuellement",
                           "register-mywort": "S'inscrire sur mywort",
                           "carousel-title-1": "Gratuit et fait pour vous",
                           "carousel-sub-1": "Partagez ce qui se passe près de chez vous ou ce qui vous touche personellement.",
                           "carousel-title-2": "Ce qui vous plaît",
                           "carousel-sub-2": "Publiez des articles et des images.",
                           "carousel-sub-2-1": "Il est possible qu'ils soient publiés dans le journal.",
                           "carousel-title-3": "Clubs, associations, administrations",
                           "carousel-sub-3": "Créez une page d'accueil pour votre organisation",
                           "carousel-title-5": "Commencez maintenant",
                           "already-member?": "Êtes-vous déjà membre?",
                           "connect": "Login",
                           "hi": "Moien",
                           "expect": "Bienvenue!",
                           "take-a-look": "Découvrez notre nouveau site web et publiez immédiatement vous premiers posts ou événements",
                           "create-first": "Créer post",
                           "create-text-footer": "Il suffit de quelques minutes - participez!",
                           "you-are-blocked": "Votre accès à mywort a été bloquée par l'administrateur de mywort.lu",
                           "contact-admin": "Contactez-nous pour plus d'informations",
                           "contact-email": "contact@mywort.lu",
                           "faq": "FAQ"
                       },
                       "geolocation": {
                           "placeholder": "Veuillez saisir une localité",
                           "choose-city": "Vérifiez votre localité",
                           "fallback-city": "La ville de Luxembourg a été sélectionnée par défaut car aucune ville correspondante n'a pu être trouvée"
                       },
                       "user-auth": {
                           "loading": "Charger",
                           "not-logged-in": "Vous n'êtes pas connecté"
                       },
                       "picture-upload": {
                           "drag-or-click-to-upload": "Glissez les images ici ou cliquez ici pour télécharger des images",
                           "remaining-pictures": "{pictures} images restantes",
                           "remove": "Supprimer",
                           "retry": "Réessayer",
                           "upload-failed-error": "Une erreur imprévue est survenue. Veuillez essayer encore une fois ou supprimer les images concernées",
                           "corrupted-pictures-error": "Quelques images sont corrompues, veuillez supprimer ces images",
                           "bad-quality-pictures-warning": "Quelques images n'ont pas la taille optimale. Pour le journal imprimé, il faut une largeur minimale de 2500 px.",
                           "not-accepted": "Ces images n'ont pas été acceptées par le serveur",
                           "bad-color-profile": "Profil de couleur non supporté",
                           "over-pixels": "La résolution de la photo doit être inférieure à 35 Mpx",
                           "over-bytes": "La taille de la photo doit être inférieure à 20 MB",
                           "try-again": "Veuillez essayer encore une fois.",
                           "not-uploaded-yet": "Pas encore téléchargé",
                           "will-be-main-picture": "Cette image est affichée comme image principale dans votre post",
                           "set-main-picture": "Définir comme image principale",
                           "main-picture": "Image principale",
                           "better-quality": "Attention : La taille de l’image n’est pas optimale. Pour le journal imprimé, il faut une largeur minimale de 2500 px."
                       },
                       "alert-box": {
                           "default-message": "Une erreur est survenue",
                           "reload-message": "Cliquez ici pour recharger la page"
                       },
                       "spinner": {
                           "timeout-title": "Une erreur est survenue...",
                           "timeout-message": "Veuillez vérifier votre connexion ou recharger la page",
                           "refresh-button-title": "Actualiser"
                       },
                       "react-validation": {
                           "error-message-field-name": "Ce champ",
                           "count-message": "{count} caractères restants",
                           "messages": {
                               "required": "%s est requis",
                               "whitespace": "%s est requis",
                               "string": {
                                   "min": "Il faut un minimum de %s caractères pour %s",
                                   "max": "%s ne peut pas dépasser %s caractères"
                               },
                               "number": {
                                   "min": "%s ne peut pas être inférieur à %s",
                                   "max": "%s ne peut pas dépasser %s"
                               }
                           }
                       },
                       "react-select": {
                           "no-result-found": "Aucun résultat trouvé"
                       },
                       "commons": {
                           "submit": "Envoyer",
                           "confirm": "Confirmer",
                           "close": "Fermer",
                           "cancel": "Annuler",
                           "go-back": "Retour",
                           "finish": "Ok",
                           "view": "Aperçu",
                           "edit": "Modifier",
                           "change": "Changer",
                           "accept": "Accepter",
                           "decline": "Refuser",
                           "delete": "Supprimer",
                           "upload": "Télécharger",
                           "locality": "Localité",
                           "users": "Utilisateur",
                           "group": "Organisation",
                           "type": "Post",
                           "post": "Nouvelle",
                           "posts": "Nouvelles",
                           "event": "Événement",
                           "events": "Événements",
                           "new-contribution": "Nouvel article",
                           "comment-for-admin": "Veuillez indiquer pour quelle(s) raison(s) vous voulez créer cette page.",
                           "picture": "Image",
                           "pictures": "Images",
                           "create-group-request": "Créer une page pour une organisation",
                           "date": "Date",
                           "view-content-in-wort": "Aperçu",
                           "view-group-in-wort": "Page",
                           "about": "Description",
                           "filter": "Filtre",
                           "clear": "Supprimer",
                           "language": "Langue"
                       },
                       "landing": {
                           "tabs": {
                               "posts": "Nouvelles",
                               "events": "Événements",
                               "localitys": "Localités",
                               "groups": "Organisations"
                           },
                           "info-box": {
                               "locality-message": "Des articles ont récemment été publiés dans ces localités :",
                               "group-message": "Des articles ont récemment été publiés par ces organisations :"
                           }
                       }
                   }
               };



// WEBPACK FOOTER //
// ./js/mywort/commons/i18n/TranslationFrench.js